import { useUser } from '../contexts/UserContext'
import { permissionType } from '../utils/constants'

export const useShippingPermissions = () => {
  const { canAccess } = useUser()

  const canViewShippingDeliveryV2 = canAccess(permissionType.VIEW_SHIPPING_DELIVERY, 0)
  const canEditShippingDeliveryV2 = canAccess(permissionType.EDIT_SHIPPING_DELIVERY, 0)
  const canManageRatesView = canAccess(permissionType.MANAGE_RATES_VIEW, 0)
  const canManageRatesEdit = canAccess(permissionType.MANAGE_RATES_EDIT, 0)

  return {
    canViewShippingDeliveryV2,
    canEditShippingDeliveryV2,
    canManageRatesView,
    canManageRatesEdit
  }
}
